import { callServer } from './server';

/**
 * A screen's data, for a route loader. "Not found" becomes the not-found
 * screen; any other failure becomes the error screen with the server's
 * message. (A lost session is handled by callServer itself.)
 */
export async function load<T>(path: string): Promise<T> {
  const result = await callServer<T>('GET', path);
  if (result.ok) return result.data;
  if (result.status === 404) throw new Response('Not Found', { status: 404, statusText: 'Not Found' });
  throw new Error(result.error);
}
